import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './ktostamm-lieferant.detail-view.html',
    styleUrls: ['./ktostamm-lieferant.detail-view.scss']
})
export class KtostammLieferantDetailView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
